const Actions = {
  MATRIX_MODEL: 'matrix_model',
  SNIPPET: 'snippet',
};

const ActionsCopyMap = {
  MATRIX_MODEL: 'run matrix',
};

const ActionOptions = {
  MATRIX_MODELS: {
    TOKEN: 'matrix_model_token',
    VERSION: 'matrix_model_public_version',
  },
};

export const APPLICABLE_WHAT_IF_WORKFLOW_TYPES = [
  'person',
  'business',
];

const OUTPUT_ATTRIBUTE_DATA_TYPES = {
  DECIMAL: 'decimal',
  INTEGER: 'integer',
  STRING: 'string',
};

const OUTPUT_ATTRIBUTE_DATA_TYPES_ARR = Object.values(OUTPUT_ATTRIBUTE_DATA_TYPES);

const OUTPUT_ATTRIBUTE_NUMBER_DATA_TYPES_ARR = [
  OUTPUT_ATTRIBUTE_DATA_TYPES.DECIMAL,
  OUTPUT_ATTRIBUTE_DATA_TYPES.INTEGER,
];

const OUTPUT_ATTRIBUTE_DEFAULT_EXPRESSION_BY_DATA_TYPE = {
  [OUTPUT_ATTRIBUTE_DATA_TYPES.DECIMAL]: [1],
  [OUTPUT_ATTRIBUTE_DATA_TYPES.INTEGER]: [1],
  [OUTPUT_ATTRIBUTE_DATA_TYPES.STRING]: [],
};

const PORTFOLIO_FREQUENCIES = {
  SCHEDULED_CRON: 'scheduled-cron',
  EVENT_DRIVEN: 'event-driven',
};

const WORKFLOW_STATUS_TYPES = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  DRAFT: 'draft',
  INACTIVE: 'inactive',
};

/*
Normally published attribute action options are saved on the published attribute.
However these options are unique to the workflow version, so we must continue to save them there.
*/

export {
  Actions,
  ActionsCopyMap,
  ActionOptions,
  OUTPUT_ATTRIBUTE_DATA_TYPES,
  OUTPUT_ATTRIBUTE_DATA_TYPES_ARR,
  OUTPUT_ATTRIBUTE_DEFAULT_EXPRESSION_BY_DATA_TYPE,
  OUTPUT_ATTRIBUTE_NUMBER_DATA_TYPES_ARR,
  PORTFOLIO_FREQUENCIES,
  WORKFLOW_STATUS_TYPES,
};

export const ATTRIBUTES_WITH_RHS_DEPENDENT_DROPDOWNS_SET = new Set([
  'alh_latest_eval_outcome',
  'alh_outcome_reason',
  'alh_reason_code',
]);

export const ATTRIBUTES_DEPENDENT_ON_JOURNEY_TOKEN_SET = new Set([
  'alh_outcome_reason',
  'alh_reason_code',
]);
